import React, { useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { Disable } from 'react-disable'
import { FormFieldConditional } from './FormFieldConditional'
import { Loading } from '@truphone/core-components'

export function FormTab(props) {
  const [thankYouMessage, setThankYouMessage] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const methods = useForm({
    mode: 'onChange',
    defaultValues: { 'product:Product:Product': props.title }
  })

  const submit = (thankYouMessage) => {
    methods.handleSubmit(async (data) => {
      setSubmitting(true)

      let formData = {}

      Object.getOwnPropertyNames(data).forEach((name) => {
        formData[decodeURIComponent(name)] = data[name]
      })

      await fetch(`${process.env.API_ENDPOINT}support/contact/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      setThankYouMessage(thankYouMessage)
      setSubmitting(false)
      setSubmitted(true)

      if (typeof props.onSubmitted === 'function') {
        props.onSubmitted()
      }
    })() //Needs to invoke itself.
  }

  if (submitted) {
    return <div className="text-base" dangerouslySetInnerHTML={{ __html: thankYouMessage }} />
  }

  if (submitting) {
    return <Loading form loadingText={props.loadingText} />
  }

  return (
    <Disable disabled={submitting}>
      <FormProvider {...methods}>
        <div
          className={`container mx-auto text-center z-1 relative ${
            props.active ? 'flex flex-wrap justify-around' : 'hidden'
          }`}
        >
          {props.field &&
            (() => {
              const values = methods.getValues()
              const emailField = Object.getOwnPropertyNames(values).find((x) => /^email/.test(x))
              const automationUser = values[emailField] === 'automation@truphone.com'
              return (
                <FormFieldConditional
                  {...props.field}
                  pageLocale={props.pageLocale}
                  userLocation={props.userLocation}
                  submit={submit}
                  automationUser={automationUser}
                />
              )
            })()}
        </div>
      </FormProvider>
    </Disable>
  )
}
